import { Component } from '@angular/core';

@Component({
  selector: 'kve-lookup-list',
  templateUrl: './lookup-list.component.html',
  styleUrl: './lookup-list.component.scss'
})
export class LookupListComponent {

}
